import React from "react";
import { Card, Button, Row, Col } from "@themesberg/react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHistory,
  faMoneyBillWave,
  faPlusCircle,
} from "@fortawesome/free-solid-svg-icons";

const Supplier = (props) => {
  const { data } = props;
  const navigate = useNavigate();
  return (
    <>
      <Card className="mb-2">
        <Card.Header>
          {data?.company_name}{" "}
          <div className="">
            {" "}
            <img src={data?.logo} />{" "}
          </div>
        </Card.Header>
        <Card.Body></Card.Body>
        <Card.Footer>
          <Row>
            <Col>
              {" "}
              <Button className="btn-sm">
                <FontAwesomeIcon icon={faPlusCircle} /> achat
              </Button>
            </Col>
            <Col>
              {" "}
              <Button className="btn-sm">Paiement</Button>
            </Col>
            <Col md={12} className="d-flex justify-content-start">
              <Button className="btn-sm mt-2">
                {" "}
                <FontAwesomeIcon icon={faHistory} /> Historique d'achat
              </Button>
            </Col>
          </Row>
        </Card.Footer>
      </Card>
    </>
  );
};
export default Supplier;
